import { render } from "./RInput.vue?vue&type=template&id=778d25b7"
import script from "./RInput.vue?vue&type=script&lang=js"
export * from "./RInput.vue?vue&type=script&lang=js"

import "./RInput.vue?vue&type=style&index=0&id=778d25b7&lang=css"
script.render = render

export default script